export default function Wrap({ className = '', children }) {
  return <div className={`mx-auto max-w-[1080px] px-7 ${className}`}>{children}</div>
}
